import type { Context } from "@outverse-video/outverse-api-client-lib";
import type { UploadedFile } from "app/utils/uploadcare";

export enum AgentMode {
  Settings = "settings",
  FullAgent = "full-agent",
  Widget = "widget",
}

export interface ConversationItem {
  id: string;
  prompt: string;
  files?: UploadedFile[];
  response?: string;
  sources?: Context[];
  feedbackState?: "positive" | "negative" | null;
  shouldDisplayDocs?: boolean;
  analysing?: boolean;
  sentiment?: number;
  isDraft?: boolean;
  escalated?: boolean;
  escalationDrain?: string;
  error?: string;
}

export interface AugmentedFile {
  id: string;
  file?: UploadedFile;
  uploading: boolean;
}
